import { getConfigurationFromDomain } from 'subDomainConfiguration';

const useCspTranslationNamespace = () => {
  const environment = getConfigurationFromDomain();
  return environment.id === 'bell' ? 'bell' : 'translation';
};

export default useCspTranslationNamespace;
